var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('h2',[_vm._v("回调查询")]),_c('el-card',{attrs:{"shadow":"hover"}},[_c('callback-search',{ref:"callbackSearchCom"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }